import { useState } from 'react';

const useForm = (initialState) => {
    //Estado de controle dos valores dos campos
    const [fields, setFields] = useState(initialState);

    //Estado de controle dos erros dos campos
    const [errors, setErrors] = useState();

    //Função para o change dos campos do formulario
    const onChange = (e) => {
        const { name, value } = e.target;
        setFields({
            ...fields,
            [name]: value
        });
    }

    const reset = () => {
        setFields(initialState);
    }
    return [ fields, errors, onChange, reset ];
}

export default useForm;